import Cropper from "cropperjs";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import bannerGeneratorHelper from "./helper";
import bannerGeneratorAction from "../../../../store/actions/bannerGenerator";
import helpersNumbers from "../../../../helpers/numbers";

function ImageBrand({ banner, setImageBanner }) {
  const [showModal, setShowModal] = useState(false);
  const [imageUpload, setImageUpload] = useState();
  const [cropper, setCropper] = useState();

  const closeModalHandler = () => setShowModal(false);
  const showModalHandler = () => setShowModal(true);

  useEffect(() => {
    if (!imageUpload) {
      return;
    }

    let cropperInstance = new Cropper(document.querySelector("#image"), {
      aspectRatio: banner.cropSize.width / banner.cropSize.height,
      viewMode: 1,
    });

    setCropper(cropperInstance);
  }, [imageUpload]);

  const inputChangeHandler = (e) => {
    const files = e.target.files;
    let reader;
    let file;
    if (files && files.length > 0) {
      file = files[0];
      reader = new FileReader();
      reader.onload = function (e) {
        done(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const done = (url) => {
    showModalHandler();
    setImageUpload(url);
  };

  const cropImage = () => {
    closeModalHandler();
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: banner.cropSize.width,
        height: banner.cropSize.height,
      });
      setImageBanner({
        imageBrand: canvas.toDataURL(),
      });
    }
  };

  return (
    <div>
      <div
        className="d-flex flex-column justify-content-around hover p-2 border border-1 bg-add-advertise-box border-dark box-upload-banner "
        onClick={(e) => {
          e.preventDefault();
          document.querySelector("#input-file-image-brand").click();
        }}
      >
        <span>تصویر اولیه را اضافه کنید</span>
        <span className="text-center">
          <img src="/assets/img/upload-banner-generator.svg" />
        </span>
      </div>
      <input
        className="form-control d-none"
        id="input-file-image-brand"
        type="file"
        name="image"
        accept="image/x-png,image/jpeg"
        onChange={inputChangeHandler}
      />

      <Modal
        id="modal-cropper-advertise-native"
        size="xl"
        style={{ zIndex: 10000000 }}
        show={showModal}
        onHide={closeModalHandler}
        backdrop="static"
        animation={true}
      >
        <Modal.Header>
          <Modal.Title>برش تصویر</Modal.Title>
        </Modal.Header>
        <Modal.Body id="modal-cropper-image-advertise-native">
          <div>
            <img className="img-fluid" id="image" src={imageUpload} />
            <div className="text-center pt-2">
              <span
                className="btn btn-primary mx-1"
                id="zoom-in-btn"
                onClick={() => {
                  cropper.zoom(0.1);
                }}
              >
                <i
                  className="fa fa-search-plus "
                  onClick={() => {
                    document.querySelector("#zoom-in-btn").click();
                  }}
                ></i>
              </span>
              <span
                className="btn btn-danger"
                id="zoom-out-btn"
                onClick={() => {
                  cropper.zoom(-0.1);
                }}
              >
                <i
                  className="fa fa-search-minus "
                  onClick={() => {
                    document.querySelector("#zoom-out-btn").click();
                  }}
                ></i>
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <span>
            <Button
              className="btn btn-warning text-white"
              onClick={() => closeModalHandler()}
            >
              خروج
            </Button>
          </span>
          <span>
            <Button
              className="btn btn-success"
              id="btn-crop"
              onClick={cropImage}
            >
              ذخیره
            </Button>
          </span>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setImageBanner: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_BANNER,
        payload: action,
      });
    },
  };
};

export default connect(
  bannerGeneratorHelper.getDetailsBanner,
  mapDispatchToProps
)(ImageBrand);
